import {PlainDtoModel} from "../../../../../../common/entity/dto/plain/plainDto.model";
import {
    InsoleElementDefinitionSummaryModel
} from "../../../../../element/definition/api/model/insoleElementDefinitionSummary.model";
import {LovValueSummary} from "../../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class InsoleDataElementModel implements PlainDtoModel{
    position: number;
    definition: InsoleElementDefinitionSummaryModel;
    height: number;
    positionValue: LovValueSummary;
    hardnesses: InsoleDataElementHardnessModel[] = [];
}

export class InsoleDataElementHardnessModel implements PlainDtoModel{
    hardness: number;
    hardnessFrom: number;
    hardnessTo: number;
}